import Box from './Box';
import Markdown from 'react-markdown';
import styled from 'styled-components';
import { useHospitalContext } from '../../../context/chatbot/HospitalContextApi';
import ThreeDotsLoading from '../Animaitons/LoadingDots';
import FileCitation from '../FileCitation';
import LocalIcon from '../../../ui/LocalIcon';
import { useQuestionContext } from '../../../context/chatbot/QuestionContextApi';
import { black, green, red } from '../../../utils/style/colors';
import { useTranslation } from 'react-i18next';

const LinkFormatterInMarkdown = styled.div`
  & a {
    font-weight: bold;
    padding: 0.2rem;
    border-radius: 0.2rem;
    text-decoration: underline;
    &:hover {
      background: #bbfbbb;
    }
  }
`;

const MoreInfoContainer = styled.div`
  display: flex;
`;

const StatusContainer = styled.div`
  width: 8rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

interface IProps {
  ans: string;
  type: number;
  annotations?: any;
  isLoading?: boolean;
  questionKey?: string;
}

const Answer: React.FC<IProps> = ({
  ans,
  type,
  annotations = [],
  isLoading = false,
  questionKey,
}) => {
  // deleting unused texts

  const { t } = useTranslation('chatbot');

  const hospitalContext = useHospitalContext();
  const questionContext = useQuestionContext();

  const isStreaming = !questionKey;

  if (!hospitalContext) {
    throw new Error('there is no hospital context!');
  }

  if (!questionContext) {
    throw new Error('there is no question context!');
  }

  const { questionList } = questionContext;
  let questionRating: 0 | 1 | null = null;
  if (questionKey !== undefined && questionKey !== '')
    questionRating = questionList.find((el) => el.key === questionKey)!.rating;

  const {
    hospitalInitialInformation: { showCitation, chatHistoryItemId },
  } = hospitalContext;
  const cleanAnswer = ans?.replace(/【.*】/g, '');
  return (
    <div
      className="col-start-2 col-span-3 flex sm:text-base text-xs justify-start items-start my-2"
      style={{ flexDirection: 'row-reverse' }}
    >
      {isLoading ? (
        <div>
          <Box id={type}>
            {cleanAnswer}
            <ThreeDotsLoading />
          </Box>
        </div>
      ) : (
        <div>
          <>
            <Box id={type}>
              <LinkFormatterInMarkdown>
                <Markdown>{cleanAnswer}</Markdown>
              </LinkFormatterInMarkdown>
            </Box>
            <MoreInfoContainer>
              {showCitation && <FileCitation annotations={annotations} />}
              {!isStreaming && chatHistoryItemId && (
                <StatusContainer>
                  <LocalIcon
                    iconName={'thumb-down.svg'}
                    onClick={() => {
                      if ((questionRating as number) === 0) return;
                      questionContext.handleChangeRating(questionKey!, 0);
                    }}
                    color={questionRating === 0 ? red : black}
                    hover={true}
                    fillHoverColor={red}
                    isLink={true}
                    title={t('dislike')}
                  />
                  <LocalIcon
                    iconName={'thumb-up.svg'}
                    onClick={() => {
                      if ((questionRating as number) === 1) return;
                      questionContext.handleChangeRating(questionKey!, 1);
                    }}
                    color={questionRating === 1 ? green : black}
                    hover={true}
                    fillHoverColor={green}
                    isLink={true}
                    title={t('like')}
                  />
                </StatusContainer>
              )}
            </MoreInfoContainer>
          </>
        </div>
      )}
    </div>
  );
};

export default Answer;
